var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtErc20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2227_5606)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2227_5606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.37271 0 0 5.37237 0 11.9999C0 18.6271 5.37271 24 12.0001 24C18.6274 24 24 18.6271 24 11.9999C24 5.37237 18.6273 0 12.0001 0Z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2227_5606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.37271 0 0 5.37237 0 11.9999C0 18.6271 5.37271 24 12.0001 24C18.6274 24 24 18.6271 24 11.9999C24 5.37237 18.6273 0 12.0001 0Z",
    fill: "#4EAF94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2549 18V13.3283C16.1052 13.1712 18.2499 12.4888 18.25 11.6712C18.25 10.8537 16.1052 10.1714 13.2551 10.0141L13.2549 8.71131H16.8136V6H7.08278V8.71131H10.6411V10.0204C7.84309 10.1886 5.75 10.8636 5.75 11.6712C5.75 12.4789 7.84309 13.154 10.6411 13.322V18H13.2549ZM13.2551 11.8964V10.3105C15.7094 10.423 17.539 10.8586 17.5391 11.3794C17.5391 11.9857 15.059 12.4768 12 12.4768C8.94077 12.4768 6.46087 11.9857 6.46087 11.3794C6.46087 10.8661 8.23908 10.4353 10.6412 10.3153V10.6242H10.6415V11.8904C11.0745 11.9154 11.5296 11.9288 11.9999 11.9288C12.4327 11.9288 12.8531 11.9173 13.2551 11.8964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: -3,
    y: 14,
    width: 29,
    height: 7,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20434 20H3V15H6.20434V15.6818H3.73946V17.0455H5.71136V17.7273H3.73946V19.3182H6.20434V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90325 20H9.16379V19.0909H8.9173V18.6364H8.67082V18.1818H8.42433V17.7273H7.43838V20H6.69892V15H9.16379V15.2273H9.41028V15.4545H9.65676V15.6818H9.90325V17.0455H9.65676V17.2727H9.41028V17.5H9.16379V17.9545H9.41028V18.4091H9.65676V18.8636H9.90325V20ZM9.16379 16.8182V15.9091H8.9173V15.6818H7.43838V17.0455H8.9173V16.8182H9.16379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6022 19.3182H13.3557V19.5455H13.1092V19.7727H12.8627V20H11.3838V19.7727H11.1373V19.5455H10.8908V19.3182H10.6443V19.0909H10.3978V15.9091H10.6443V15.6818H10.8908V15.4545H11.1373V15.2273H11.3838V15H12.8627V15.2273H13.1092V15.4545H13.3557V15.6818H13.6022V16.3636H12.8627V15.9091H12.6162V15.6818H11.6303V15.9091H11.3838V16.1364H11.1373V18.8636H11.3838V19.0909H11.6303V19.3182H12.6162V19.0909H12.8627V18.6364H13.6022V19.3182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3011 20H14.0967V18.1818H14.3432V17.9545H14.5897V17.7273H14.8362V17.5H15.0827V17.2727H16.0686V17.0455H16.3151V16.8182H16.5616V15.9091H16.3151V15.6818H15.0827V15.9091H14.8362V16.3636H14.0967V15.6818H14.3432V15.4545H14.5897V15.2273H14.8362V15H16.5616V15.2273H16.8081V15.4545H17.0546V15.6818H17.3011V17.0455H17.0546V17.2727H16.8081V17.5H16.5616V17.7273H16.3151V17.9545H15.3292V18.1818H15.0827V18.4091H14.8362V19.3182H17.3011V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19.0909H20.7535V19.3182H20.507V19.5455H20.2605V19.7727H20.014V20H18.7816V19.7727H18.5351V19.5455H18.2886V19.3182H18.0422V19.0909H17.7957V15.9091H18.0422V15.6818H18.2886V15.4545H18.5351V15.2273H18.7816V15H20.014V15.2273H20.2605V15.4545H20.507V15.6818H20.7535V15.9091H21V19.0909ZM20.014 16.1364V15.9091V15.6818H18.7816V15.9091H18.5351V18.4091H18.7816V17.9545H19.0281V17.5H19.2746V17.0455H19.5211V16.5909H19.7676V16.1364H20.014ZM20.2605 19.0909V16.8182H20.014V17.2727H19.7676V17.7273H19.5211V18.1818H19.2746V18.6364H19.0281V19.0909H18.7816V19.3182H20.014V19.0909H20.2605Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2227_5606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtErc20);
export default __webpack_public_path__ + "static/media/USDT-ERC20.a74ceca75f5b06095c67a9854b377d21.svg";
export { ForwardRef as ReactComponent };